/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
  FormFieldType,
  IFormTextArea,
  IFormValidatable,
  RequiredValidations,
} from '../typings';
import { BaseFormFieldBuilder } from '.';

type Validations = RequiredValidations<IFormTextArea['validations']>;

export class TextAreaFormFieldBuilder
  extends BaseFormFieldBuilder<IFormTextArea>
  implements IFormValidatable<Validations>
{
  // @ts-ignore
  private _type = FormFieldType.TextArea as const;
  private _validations?: Validations;
  // @ts-ignore
  private _helperText?: IFormTextArea['helperText'];

  constructor() {
    super();
  }

  public helperText(value: IFormTextArea['helperText']): this {
    this._helperText = value;
    return this;
  }

  public validation(value: Validations[number]): this {
    if (this._validations) {
      this._validations.push(value);
    } else {
      this._validations = [value];
    }

    return this;
  }

  public validations(value: Validations): this {
    if (this._validations) {
      this._validations.push(...value);
    } else {
      this._validations = [...value];
    }

    return this;
  }
}
